import client from "../api/client";
export const getList = () => {
  return client('/api/building-stats').then(({ data }) => data.data);
};

export const getLastStats = (buildingId) => {
  return client(`/api/building-stats/last-stats/${buildingId}`).then(({ data }) => data.data);
};
export const getDetail = (id) => {
  return client(`/api/building-stats/${id}`).then(({ data }) => data.data);
};

export const getStatDetail = (buildingId, buildingStatTypeId) => {
  return client(`/api/building-stats/building-stat-type-detail/${buildingId}/${buildingStatTypeId}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/building-stats/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/building-stats', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const syncBuildingStats = (values= {}) => {
  return client('/api/sync-building-stats', {method: 'post', body: values}).then(({ data }) => data.data);
};

export const delModel = (id) => {
    return client(`/api/building-stats/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useBuildingStatService () {
  return {
    getList,
    getLastStats,
    getStatDetail,
    addEditModel,
    getDetail,
    delModel,
    syncBuildingStats,
  };
}
